<template>
  <div class="create-agency">
    <div class="create-agency__title">Create New Agency</div>
    <label class="create-agency__input">
      <span class="create-agency__label">Is Active</span>
      <div class="create-agency__link-wrapper">
        <base-select
          shiftLabelRight
          alignLeft
          class="create-agency__category"
          :class="{'form-control_error': externalErrors.category_id}"
          :options="activeOpts"
          v-model="agency.is_active"
          :max-height-list="450"
          :titleStyle="{ overflow: 'visible' }"
        />
        <span class="create-agency__error-message"
              v-if="externalErrors.category_id">{{externalErrors.category_id}}</span>
      </div>
    </label>
    <label class="create-agency__input">
      <span class="create-agency__label">Name</span>
      <div class="create-agency__link-wrapper">
        <input type="text"
               class="form-control create-agency__link-field"
               placeholder="Enter the Agency Name"
               :class="{'form-control_error': externalErrors.name}"
               v-model="agency.name">
        <span class="create-agency__error-message" v-if="externalErrors.name">{{externalErrors.name}}</span>
      </div>
    </label>
    <label class="create-agency__input">
      <span class="create-agency__label">Email</span>
      <div class="create-agency__link-wrapper">
        <input type="text"
               class="form-control create-agency__link-field"
               placeholder="Enter the Agency Email"
               :class="{'form-control_error': externalErrors.email}"
               v-model="agency.email">
        <span class="create-agency__error-message" v-if="externalErrors.email">{{externalErrors.email}}</span>
      </div>
    </label>
    <div class="create-agency__controls">
      <button class="create-agency__button create-agency__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="create-agency__button create-agency__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

const OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export default {
  name: 'CreateAgencyPopup',
  mixins: [BaseModalMixins],
  data () {
    return {
      agency: {
        name: '',
        email: '',
        id: -1,
        is_active: 1
      },
      activeOpts: [...OPTIONS],
      externalErrors: {}
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    apply () {
      this.$emit('apply', this.agency)
    }
  }
}
</script>

<style lang="scss">
.create-agency {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;
  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin: 9px 0 35px;
    color: $rfx-dark-march;
  }
  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;
    &_invalid[type='text'] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }
  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }
  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;
    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;
      &:disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }
    }
    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }
  &__link {
    &-wrapper {
      position: relative;
    }
    &-field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      font-weight: 500;
      @include ellipsis;
    }
  }
  &__error-message {
    color: $rfx-red;
    font-size: 10px;
    margin-top: 5px;
  }
}
.form-control {
  height: 50px;
  padding: 0 20px;
  border: 1px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;
  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }
  &:disabled {
    background-color: $rfx-light-steel;
  }
  &_error {
    border-color: $rfx-red;
    color: $rfx-red;
    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }
  }
}
.description {
  width: 100%;
  height: 90%;
  padding: 0;
  resize: none;
  outline: none;
  border: none;
  font-size: 14px;
  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
    margin-top: -5px;
  }
  &__wrapper {
    padding: 10px 20px;
    height: auto;
  }
}
</style>
